// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__2Zqhp","wrapper":"style_wrapper__cM6p9"};